import React from 'react';

import { GtpWalletInfoResult } from '@eika-infrastruktur/mobilbank-lib';
import InfoMessage from '@eika/attention-message/lib/InfoMessage';
import { IconTypes } from '@eika/icon';

import { GooglePayData } from '@/domain/digital-wallet/types';

import { useSession } from '@components/app/Session';
import useText from '@hooks/use-text';

import { AddToGooglePaySteppedUp, AddToGooglePayWithSigning } from './button/AddToGooglePayButton';

import './AddToGooglePay.scss';
import { V4AddToGooglePaySteppedUp } from './button/V4AddToGooglePay';

interface AddToGooglePayProps {
    data: GooglePayData;
    startGooglePayActivationWithSigning: () => void;
    googleWalletInfo: GtpWalletInfoResult;
}

export const AddToGooglePay = ({
    data,
    startGooglePayActivationWithSigning,
    googleWalletInfo,
}: AddToGooglePayProps) => {
    const { googleWalletProcessStartInformation } = useText();
    const session = useSession();

    if (data.source === 'kb') {
        return (
            <div className="add-to-google-pay-container">
                <V4AddToGooglePaySteppedUp data={data} googleWalletInfo={googleWalletInfo} />
            </div>
        );
    }

    if (session.highAssurance) {
        return (
            <div className="add-to-google-pay-container">
                <AddToGooglePaySteppedUp card={data.card} googleWalletInfo={googleWalletInfo} />
            </div>
        );
    }

    return (
        <div className="add-to-google-pay-container">
            <InfoMessage
                type="info"
                id="google-pay-process-start-information"
                text={googleWalletProcessStartInformation}
                icon={IconTypes.INFO_24}
            />
            <AddToGooglePayWithSigning startGooglePayActivationWithSigning={startGooglePayActivationWithSigning} />
        </div>
    );
};
